<template>
    <div class="product-categories">
        <div class="is-hidden-mobile">
            <aside class="menu">
                <ul class="menu-list">
                    <li v-for="category in categories" :key="category.id" :class="{'active': category === selectedCategory}">
                        <a @click="onCategorySelected(category)">
                            <template v-if="category.name === 'Le Pain Quotidien'">
                                <img width="180" src="@/assets/img/category-lpq.png" />
                            </template>
                            <template v-else>
                                {{ category.name }}
                            </template>
                        </a>
                    </li>
                </ul>
            </aside>
        </div>

        <div class="is-hidden-tablet">
            <b-field label="Categoría">
                <b-dropdown>
                    <button class="button" slot="trigger">
                        <span v-if="selectedCategory">{{ selectedCategory.name }}</span>
                        <span v-else>Categoría</span>

                        <b-icon icon="menu-down"></b-icon>
                    </button>

                    <b-dropdown-item v-for="category in categories" :key="category.id" v-on:click="onCategorySelected(category)">
                        {{ category.name }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-field>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductCategories',
        props: ['categories', 'selectedCategory'],
        data() {
            return {}
        },

        methods: {
            onCategorySelected(category) {
                this.$emit('category-changed', category);
            }
        },

        filters: {
            uppercase(value) {
                return value.toUpperCase();
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>